'use strict';

import { Store } from 'vuex';

export default class UtilsConfig {
    public static initialize(store: Store<unknown>) {
        store.commit('rearchitected/initializeUtils', store.state);
    }
}
